/**
 * Utility functions for device detection
 */

/**
 * Detect if the current device is a mobile device
 * Based on userAgent string
 * 
 * @returns {boolean} true if mobile device, false if desktop
 */
export const isMobileDevice = () => {
  if (typeof window === 'undefined' || !navigator) {
    console.log('[DeviceDetection] Window or navigator not available');
    return false;
  }

  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  
  // Pattern to match mobile devices
  // Include common mobile indicators
  const mobilePattern = /iPhone|iPad|iPod|Android|webOS|BlackBerry|IEMobile|Opera Mini|Mobile|mobile|CriOS|Fennec|Windows Phone|Kindle|Silk|PlayBook|BB10|Tablet/i;
  
  const isMobile = mobilePattern.test(userAgent);
  
  // Debug logging
  console.log('[DeviceDetection] UserAgent:', userAgent);
  console.log('[DeviceDetection] Is Mobile:', isMobile);
  console.log('[DeviceDetection] Screen width:', window.screen?.width);
  console.log('[DeviceDetection] Screen height:', window.screen?.height);
  
  // Additional check: screen size (backup method)
  // If screen width is less than 768px, likely mobile
  const screenWidth = window.screen?.width || window.innerWidth;
  const isSmallScreen = screenWidth < 768;
  
  // Return true if either userAgent matches OR screen is small
  // But prioritize userAgent for accuracy
  const result = isMobile || (isSmallScreen && !/Windows|Macintosh|Linux/i.test(userAgent));
  
  console.log('[DeviceDetection] Final result:', result);
  
  return result;
};

/**
 * Get device type as string
 * @returns {string} 'mobile' or 'desktop'
 */
export const getDeviceType = () => {
  return isMobileDevice() ? 'mobile' : 'desktop';
};
